import { render } from "./PackageList.vue?vue&type=template&id=96b2aa96"
import script from "./PackageList.vue?vue&type=script&lang=js"
export * from "./PackageList.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__